import { Route } from "react-router-dom";

import { db } from "astrid-firebase";

import ForwardContext from "../../../layouts/ForwardContext";

import FirestoreDocumentElement from "../../firebase/components/FirestoreDocumentElement";

import Serie from "../pages/Serie/Serie";
import SerieOverview from "../pages/Serie/SerieOverview";
import Series from "../pages/Series";

export const series = (
	<Route path="series" element={<ForwardContext />} handle={{ crumb: ({ t }) => t("series", "Series") }}>
		<Route index element={<Series />} />

		<Route
			path=":serie"
			element={<FirestoreDocumentElement param="serie" collection={db.collection("series")} />}
			handle={{ crumb: ({ serie }) => serie?.name }}
		>
			<Route element={<Serie />}>
				<Route index element={<SerieOverview />} />
			</Route>
		</Route>
	</Route>
);
